import { css } from '@emotion/core'
import { colors, Heading, HFlow, VFlow } from 'bold-ui'
import { MChatMarca } from 'view/atendimentos/detail/soap/objetivo/puericultura/mchat-rf/components/MChatMarca'

import { MChat } from '../../consulta/HistoricoObjetivoPecPanel'
import { HistoricoMChatRfTableBox } from './HistoricoMChatRfTableBox'
import { HistoricoMChatTableBox } from './HistoricoMChatTableBox'

interface HistoricoMChatPanelProps {
  mChats: ReadonlyArray<MChat>
  idadeEmMeses: number
}

export function HistoricoMChatPanel(props: Readonly<HistoricoMChatPanelProps>) {
  const { mChats, idadeEmMeses } = props

  if (!mChats || mChats.length === 0) {
    return null
  }

  return (
    <VFlow vSpacing={0.5}>
      <HFlow alignItems='center' justifyContent='space-between'>
        <Heading level={3} style={styles.heading}>
          M-CHAT-R/F™ (Checklist Modificado para Autismo em Crianças Pequenas)
        </Heading>
        <MChatMarca />
      </HFlow>
      {mChats.map((mChat) =>
        mChat.isMchatRf ? (
          <HistoricoMChatRfTableBox key={mChat.id} risco={mChat.risco} pontuacao={mChat.pontuacao} />
        ) : (
          <HistoricoMChatTableBox
            key={mChat.id}
            risco={mChat.risco}
            pontuacao={mChat.pontuacao}
            aplicacao={mChat.aplicacao}
            cidadaoIdadeEmMeses={idadeEmMeses}
          />
        )
      )}
    </VFlow>
  )
}

const styles = {
  heading: css`
    color: ${colors.turquoise.c40};
  `,
}
